export const EXTERNAL_COLLECTION_NOTICE_STATUS_BILLED = 'Timbrado';
export const EXTERNAL_GENERIC_EMAIL = '@rcsa.hub';
